<template>
  <div class="lang-box">

    <el-dropdown trigger="click" @command="handleChangeLang">
        <span class="el-dropdown-title">
          {{ $t('lang.语言') }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="i" v-for="i in langInfo" :key="i.lang">{{ i.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {loadTagsByLang} from "../../js/common";

export default {
  name: "lang",
  data() {
    return {
      langInfo: [
        {lang: 'zh', name: '中文'},
        {lang: 'en', name: 'English'},
      ],
    }
  },
  methods: {
    handleChangeLang(lang) {
      this.$i18n.locale = lang.lang;
      loadTagsByLang(this);
    },
  }
}
</script>

<style scoped lang="scss">

.lang-box {
  .el-dropdown-title {
    cursor: pointer;
  }
}

</style>
